module.exports = __webpack_public_path__ + "img/Oromia_Certificate.23f4923f.jpg";